import Subscribe from "common/Layout/Section/Subscribe";
import CenterWrapper from "Components/CenterWrapper";
import Title from "Components/Title";

const Subscription = () => {
  return (
    <CenterWrapper>
      <Title type="success">Our Subscription</Title>
      <Subscribe />
    </CenterWrapper>
  );
};

export default Subscription;
